import { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useAddNewResponseMutation } from "./responsesApiSlice"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave, faArrowAltCircleRight, faAlignLeft, faAlignRight } from "@fortawesome/free-solid-svg-icons"
import { useGetActionsQuery } from "../actions/actionsApiSlice"
import PulseLoader from "react-spinners/PulseLoader"
import EditNewResponseHeader from "./EditNewResponseHeader"
import ResponseText from "../../partial/ResponseText"
import ResponseCode from "../../partial/ResponseCode"
import ResponseFile from "../../partial/ResponseFile"
import AdditionList from "../../partial/AdditionList"
import BooleansResponse from "../../partial/BooleansResponse"
import getFilePath from "../../utils/getFilePath"
import { FriendsCheckbox } from "../../components/FriendsCheckbox"
const NewResponseForm = ({task}) => {
    const { actionId, taskId, groupId , type: urlType} = useParams()

    const { action } = useGetActionsQuery("actionsList", {
        selectFromResult: ({ data }) => ({
            action: data?.entities[actionId]
        }),
    })  
    const [addNewResponse, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useAddNewResponseMutation()

    const navigate = useNavigate()

    const [body, setBody] = useState('')
    const [comments, setComments] = useState('')
    const [additions, setAdditions] = useState([])
    const [booleans, setBooleans] = useState({})
    const [friends, setFriends] = useState([])


    useEffect(() => {
        if (isSuccess) {
            setBody('')
            setComments('')
            setBooleans({})
            navigate(`/${urlType}/${groupId}/tasks/${taskId}/actions`)
        }
    }, [isSuccess,taskId, navigate])
    if (!action ) return <PulseLoader color={"#FFF"} />
    const additionOk = () =>{
        let flag = true
        if(!action.additions?.length) {
            return flag;
        }
        const ids  = action.additions.filter(x=>x.required).map(addition=>addition._id)
        if(!ids.length) {
            return flag;
        }
        if(!additions) /*no addition but there are some that required*/
        {
            flag = false;
            return flag;
        }

        ids.map(id=>{
           const currAddition = additions.filter(addition=>id ===addition.qid);
            if(!currAddition?.length ||!currAddition[0].body) {
                flag = false;
                return flag;
            } 
        })
        return flag;
    }
    const canSave = [body].every(Boolean) && !isLoading && additionOk()

    const onSaveResponseClicked = async (e) => {
        e.preventDefault()
        if (canSave ) {
            await addNewResponse({ body,comments,additions, booleans, action:actionId, task:taskId, group:task.group, friends })
        }
    }



    const errClass = isError ? "errmsg" : "offscreen"
    const type = action?.type || "Text"
    const content = (
        <>
            <p className={errClass}>{error?.data?.message}</p>

            <form className="form" onSubmit={onSaveResponseClicked}>
            <EditNewResponseHeader/>

                <div className="form__title-row">
                    <div className="form__action-buttons">
                    <button
                            className="icon-button"
                            title="Back to action"
                            onClick={()=>{ navigate(`/${urlType}/${groupId}/tasks/${action.task}/actions`)}}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>
                        <button
                            className="icon-button"
                            title="Save"
                            disabled={!canSave}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                       
                    </div>
                </div>
                {action.img && <img className="user-img" src={getFilePath(action.img)} />}

                <>
                    {type==="Text"&& <ResponseText action={action} body={body} setBody={setBody} />}
                    {type==="Code"&& <ResponseCode action={action} body={body} setBody={setBody} />}
                    {type==="File"&& <ResponseFile action={action} body={body} setBody={setBody} />}
                  
                </>
              
            
                <AdditionList action={action} additions={additions} setAdditions={setAdditions} />
                <BooleansResponse action={action} booleans={booleans} setBooleans={setBooleans} />

                <FriendsCheckbox group={task.group} friends={friends} setFriends={setFriends} />

                <label className="form__label" htmlFor="text">
                    הערות משתמש:</label>
                <textarea
                    className={`form__input form__input--text`}
                    id="comments"
                    name="comments"
                    value={comments}
                    onChange={(e)=>setComments(e.target.value)}
                />
            </form>
        </>
    )

    return content
}

export default NewResponseForm